import { render } from "./WateredRegionInput.vue?vue&type=template&id=45aae5d5&scoped=true"
import script from "./WateredRegionInput.vue?vue&type=script&lang=js"
export * from "./WateredRegionInput.vue?vue&type=script&lang=js"

import "./WateredRegionInput.vue?vue&type=style&index=0&id=45aae5d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45aae5d5"]])

export default __exports__